import script from "./zzjOrderRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./zzjOrderRecord.vue?vue&type=script&setup=true&lang=js"

import "./zzjOrderRecord.vue?vue&type=style&index=0&id=7a0c9d88&lang=scss"

const __exports__ = script;

export default __exports__